// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"Convenio_containerPrincipal__DctpR","alerta":"Convenio_alerta__pDqmt","divConvenio":"Convenio_divConvenio__tzkga"};